export default "/_next/static/chunks/fonts/Lato-Black-latin-702f21beadfa4b8bfa6b4f07ad9e7cd5.woff2";